import React from 'react';
import team from './teamlist';
import './team.css'

const TeamStructure = () => {
  const memcard = (member) => {
    return (
      <div class="memcard" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <img id='dp' src={require(`./pics/${member.id}.jpg`)} alt={member.name} style={{ borderRadius: 5, marginTop: '5%', aspectRatio: 1, width: '90%' }} />
        <div className="infocont">
          <p>{member.name}</p>
          <p>{member.post}</p>
        </div>
        {/* <img id='arr' src={require('./downarrow.png')}/> */}
        <div className='xtra'>
          <p >{member.dept} </p>
          <p >{member.hostel} </p>
        </div>
        <div className='contact' style={{ display: 'inline-block', paddingBottom: '10%' }}>
          <a href={member.linkedin} target='_blank' ><img src={require('./linkedin.png')} width={'15%'} /></a>
          <a href={`mailto:${member.mail}`} target='_blank' ><img src={require('./mail.png')} width={'15%'} /></a>
        </div>
      </div>
    )
  }
  const execard = (member) => {
    return (
      <div class="memcard" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <img id='dp' src={require(`./pics/${member.id}.jpg`)} alt={member.name} style={{ borderRadius: 5, marginTop: '5%', aspectRatio: 1, width: '90%' }} />
        <div className="exeinfocont">
          <p style={{ paddingBottom: '0%' }}>{member.name}</p>
          {/* <p>{member.post}</p> */}
        </div>
        {/* <img id='arr' src={require('./downarrow.png')}/> */}
        <div className='xtra'>
          <p>{member.dept} </p>
          <p>{member.hostel} </p>
        </div>
        <div className='contact' style={{ display: 'inline-block', paddingBottom: '1%', paddingTop: '0%', marginTop: '0%' }}>
          <a href={member.linkedin} target='_blank' ><img src={require('./linkedin.png')} width={'15%'} /></a>
          <a href={`mailto:${member.mail}`} target='_blank' ><img src={require('./mail.png')} width={'15%'} /></a>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='team'>
        {/* <h1 className='teamtitle'>
        THE TEAM
      </h1> */}
        <div className='container' >
          {team.mentors.map((member) => {
            return (
              <div className='column' key={member.id} style={{ float: 'left' }}>
                {memcard(member)}
              </div>
            )
          })}
        </div>
        {/* Executives */}
        <div className='trow'>
          {team.executives.map((member) => {
            return (
              <div className='columnthin' key={member.id}>
                {execard(member)}
              </div>
            )
          })}
        </div>
        <div className="feedback">
          <button
            onClick={() => { alert("Thank You for the valuable Feedback"); window.open('https://forms.gle/QwNnosWSkoCgfp5VA', '_blank') }}
            className="feedback-button"
          >
            🚀 Give Feedback
          </button>
        </div>
        <img src={require('./team.jpg')} style={{ width: '90%', height: 'auto', marginTop: '2em',marginLeft: window.innerWidth > 600 ? '0' : '15%' }} />
        <footer style={{ background: 'transparent', marginTop: '2em', textAlign: 'center', width: '100%', marginLeft: window.innerWidth > 600 ? '0' : '11%' }}>
          <p>&copy; 2024 Robotics Club IIT Delhi. All rights reserved.</p>
          <p style={{ fontSize: 14 }}>Designed & Developed by <a href='https://www.linkedin.com/in/sthitapragyan-mallick-192a81284/' style={{ textDecoration: 'none', color: 'black' }} target='_blank'>Sthitapragyan</a></p>
        </footer>
      </div>
    </>
  );
};

export default TeamStructure;
